import { type RootState } from '../store';

export const selectCustomerId = (state: RootState) => {
  const memberId = state.customer.customer?.memberId;
  return memberId === '' ? undefined : memberId;
};
export const selectCustomerFromStore = (state: RootState) => state.customer.customer;
export const selectCustomerCountryCode = (state: RootState) => state.customer.customer?.countryCode;
export const selectCustomerInput = (state: RootState) => state.customer.customerInput;
